import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicStyleLoaderService } from '../../utilities/dynamic-style-loader';

@Component({
    selector: 'my-account-name-edit',
    templateUrl: './name-edit.component.html',
    styleUrls: ['./name-edit.component.scss'],
    standalone: false
})
export class NameEditComponent implements OnInit {
  
  dialogData:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dynamicStyleLoader: DynamicStyleLoaderService) {
    this.dialogData = data.parentInstance;
   }  
  
  ngOnInit(){
    this.dynamicStyleLoader.focusCloseButton('mob-focus-CFA','desktop-focus-CFA');     
  }
 
}
 

